import { Typography, TextField, Stack } from "@mui/material";
import React, { useState } from "react";
import { useFiltersWithContext } from "../filter-context/useFiltersWithContext";
import { useTranslation } from "../../../hooks/useTranslation";

type TextFilterProps = {
  name: string;
  labelKey: string;
  labelVars?: Record<string, string>;
  operator?: "contains" | "eq";
  convertTo?: "lowercase" | "uppercase";
};

export const TextFilter = (props: TextFilterProps) => {
  const { name, labelKey, labelVars, operator = "contains", convertTo } = props;

  const normalizeValue = (val: string) => {
    if (convertTo === "lowercase") return val.toLowerCase();
    if (convertTo === "uppercase") return val.toUpperCase();
    return val;
  };

  const { getFilterValue, setFilter, deleteFilter } = useFiltersWithContext();
  const { translate } = useTranslation();

  const [value, setValue] = useState<string>(
    getFilterValue(name, operator)?.toString() ?? "",
  );

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    const rawValue = e.target.value;

    const normalizedValue = normalizeValue(rawValue);

    setValue(normalizedValue);

    if (normalizedValue.trim() !== "") {
      setFilter({
        field: name,
        value: normalizedValue,
        labelInfo: {
          descriptionKey: labelKey,
          value: normalizedValue,
        },
        operator,
      });
    } else {
      deleteFilter(name, operator);
    }
  };

  return (
    <Stack direction={"row"} alignItems={"center"}>
      <Typography flex={1}>{translate(labelKey, labelVars)}</Typography>
      <TextField
        size="small"
        type="text"
        value={value}
        onChange={handleChange}
        sx={{ minWidth: 200 }}
      />
    </Stack>
  );
};
